import { addClass } from './Html';
import { whiteAreaIcons } from './Icon';
export const getActivitiesOrEvents = (eventInfo) => {
    let activities = [];
    if (eventInfo.event.extendedProps && eventInfo.event.extendedProps.activities) {
        activities = eventInfo.event.extendedProps.activities;
    }
    else {
        activities = eventInfo.event.extendedProps.events;
    }
    return activities;
};
export const hasActivities = (eventInfo) => {
    const event = eventInfo.event;
    if (event.extendedProps.activities && event.extendedProps.activities.length && event.extendedProps.activities[0].subjects) {
        return true;
    }
    return false;
};
export const hasActivitiesrOrEvents = (eventInfo) => {
    const event = eventInfo.event;
    if (event.extendedProps.activities && event.extendedProps.activities.length) {
        return true;
    }
    if (event.extendedProps.events && event.extendedProps.events.length) {
        return true;
    }
    return false;
};
export const retrieveCalendarEventElement = (eventInfo, filterType) => {
    const element = eventInfo.el;
    const content = element.getElementsByClassName('fc-content')[0];
    if (!content) {
        return null;
    }
    if (filterType !== 'students') {
        return content;
    }
    const title = element.getElementsByClassName('fc-title')[0];
    const subjectProp = 'areas';
    getActivitiesOrEvents(eventInfo).forEach((activity) => {
        if (activity.is_chosen) {
            activity[subjectProp][0] ? title.innerHTML = `<img class="avatar" src="${activity[subjectProp][0] ? whiteAreaIcons[activity[subjectProp][0].icon] : ''}" />` + activity[subjectProp][0].name : '';
        }
    });
    return content;
};
export const renderCustomTimeslot = (eventInfo, filterType = null, eventClass = '', activities) => {
    const content = retrieveCalendarEventElement(eventInfo, filterType ? filterType : '');
    if (!content) {
        return eventInfo.el;
    }
    const clone = eventInfo.el.cloneNode(true);
    if (eventClass.length) {
        addClass(clone, eventClass);
    }
    const customContent = document.createElement('div');
    addClass(customContent, 'fc-content-custom');
    if (!filterType) {
        customContent.innerHTML = customTimeslotHTMLString(eventInfo, activities);
    }
    else if (!hasActivitiesrOrEvents(eventInfo)) {
        return false; // if filters but no activities hide slot
    }
    else if (filterType === 'students') {
        customContent.innerHTML = customTimeslotStudentHTMLString(eventInfo);
    }
    else if (filterType === 'users') {
        customContent.innerHTML = customTimeslotTeacherHTMLString(eventInfo);
    }
    else if (filterType === 'subjects') {
        customContent.innerHTML = customTimeslotSubjectHTMLString(eventInfo);
    }
    else if (filterType === 'levels') {
        customContent.innerHTML = customTimeslotLevelHTMLString(eventInfo);
    }
    else if (filterType === 'groups') {
        customContent.innerHTML = customTimeslotGroupHTMLString(eventInfo);
    }
    else if (filterType === 'rooms') {
        customContent.innerHTML = customTimeslotRoomHTMLString(eventInfo);
    }
    clone.appendChild(customContent);
    return clone;
};
export const renderCustomEvent = (eventInfo, filterType = null) => {
    const content = retrieveCalendarEventElement(eventInfo, filterType ? filterType : '');
    if (!content) {
        return eventInfo.el;
    }
    const clone = eventInfo.el.cloneNode(true);
    const customContent = document.createElement('div');
    addClass(customContent, 'fc-content-custom');
    if (!filterType) {
        return eventInfo.el;
    }
    else if (filterType === 'users') {
        customContent.innerHTML = customEventTeacherHTMLString(eventInfo);
    }
    else if (filterType === 'subjects') {
        customContent.innerHTML = customEventSubjectHTMLString(eventInfo);
    }
    else if (filterType === 'levels') {
        customContent.innerHTML = customEventLevelHTMLString(eventInfo);
    }
    else if (filterType === 'groups') {
        customContent.innerHTML = customEventGroupHTMLString(eventInfo);
    }
    else if (filterType === 'rooms') {
        customContent.innerHTML = customEventRoomHTMLString(eventInfo);
    }
    clone.appendChild(customContent);
    return clone;
};
const createLevelString = (levels) => {
    let levelsStr = '';
    levels.forEach((level) => {
        levelsStr += `<span class="${level.is_mandatory ? 'fc-mandatory' : ''}">${level.name}</span>, `;
    });
    return levelsStr.substring(0, levelsStr.length - 2);
};
const createGroupString = (groups) => {
    let groupsStr = '';
    groups.forEach((group) => {
        groupsStr += `<span class="${group.is_mandatory ? 'fc-mandatory' : ''}">${group.name}</span>, `;
    });
    return groupsStr.substring(0, groupsStr.length - 2);
};
const customTimeslotHTMLString = (eventInfo, activitiesString) => {
    if (!eventInfo.event.extendedProps.activities && !eventInfo.event.extendedProps.events) {
        return '';
    }
    const activities = getActivitiesOrEvents(eventInfo);
    const text = activitiesString;
    return `<span>${activities.length} ${text}</span>`;
};
const customTimeslotStudentHTMLString = (eventInfo) => {
    const activities = getActivitiesOrEvents(eventInfo);
    let subjectProp = 'areas';
    let hasChosenLesson = false;
    activities.find((activity) => {
        return activity.is_chosen == true ? hasChosenLesson = true : hasChosenLesson = false;
    });
    if (hasActivities(eventInfo)) {
        subjectProp = 'subjects';
    }
    let innerHTML = '';
    activities.forEach((activity) => {
        if (activity.type !== 'recess' && hasChosenLesson) {
            if (activity.is_chosen) {
                innerHTML += `
        <div class="activity">
          <ul class="customEventInfo">`;
                if (activity.teacher) {
                    innerHTML += `
            <li>
              <img class="avatar" src="${activity.teacher.avatar}" />
              ${activity.teacher.name}
            </li>`;
                }
                innerHTML += `
            <li>
              <span class="avatar" style="background-color:${activity.room ? activity.room.color : ''};"></span>
              ${activity.room ? activity.room.name : ''}
            </li>
            <li>${createLevelString(activity.levels)}</li>
            <li>${createGroupString(activity.groups)}</li>
          </ul>
        </div>
        `;
            }
        }
        else if (activity.type === 'recess') {
            innerHTML = '';
        }
        else {
            innerHTML += `
        <div class="activity">
          <ul class="customEventInfo">`;
            if (activity.teacher) {
                innerHTML += `
            <li>
              <img class="avatar" src="${activity.teacher.avatar}" />
              ${activity.teacher.name}
            </li>`;
            }
            innerHTML += `
            <li>
              <span class="avatar" style="background-color:${activity.room ? activity.room.color : ''};"></span>
              ${activity.room ? activity.room.name : ''}
            </li>
            <li>${createLevelString(activity.levels)}</li>
            <li>${createGroupString(activity.groups)}</li>
          </ul>
        </div>
        `;
        }
    });
    return innerHTML;
};
const customTimeslotTeacherHTMLString = (eventInfo) => {
    const activities = getActivitiesOrEvents(eventInfo);
    let subjectProp = 'areas';
    if (hasActivities(eventInfo)) {
        subjectProp = 'subjects';
    }
    let innerHTML = '';
    activities.forEach((activity) => {
        if (activity.type !== 'recess') {
            innerHTML += `
        <div class="activity teacher-activity ${activity.id}">
          <ul class="customEventInfo">
            <li>
              <div class="layout row align-center">
                <div>
                  <img class="avatar" style="background-color:${activity[subjectProp] && activity[subjectProp][0] ? activity[subjectProp][0].color : ''};" src="${activity[subjectProp][0] ? whiteAreaIcons[activity[subjectProp][0].icon] : ''}" />
                </div>
                <div class="flex sm10">
                    <div class="layout row wrap">
                      <div class="flex sm12 activity_area">${activity[subjectProp] && activity[subjectProp][0] ? activity[subjectProp][0].name : ''}</div>
                      <div class="flex sm12 activity_topic">${activity.topics && activity.topics[0] ? activity.topics[0].name : ''}</div>
                    </div>
                </div>
              </div>
            </li>
            <li>
              <span class="avatar" style="background-color:${activity.room ? activity.room.color : ''};"></span>
              ${activity.room ? activity.room.name : ''}
            </li>
            <li>${createLevelString(activity.levels)}</li>
            <li>${createGroupString(activity.groups)}</li>
          </ul>
        </div>
      `;
        }
    });
    return innerHTML;
};
const customTimeslotSubjectHTMLString = (eventInfo) => {
    const activities = getActivitiesOrEvents(eventInfo);
    let innerHTML = '';
    activities.forEach((activity) => {
        if (activity.type !== 'recess') {
            innerHTML += `
      <div class="activity">
        <ul class="customEventInfo">
          <li>

            <img class="avatar" src="${activity.teacher ? activity.teacher.avatar : ''}" />
            ${activity.teacher ? activity.teacher.name : ''}
          </li>
          <li>
              <span class="avatar" style="background-color:${activity.room ? activity.room.color : ''};"></span>
              ${activity.room ? activity.room.name : ''}
            </li>
          <li>${createLevelString(activity.levels)}</li>
          <li>${createGroupString(activity.groups)}</li>
        </ul>
      </div>
      `;
        }
    });
    return innerHTML;
};
const customTimeslotLevelHTMLString = (eventInfo) => {
    const activities = getActivitiesOrEvents(eventInfo);
    let subjectProp = 'areas';
    if (hasActivities(eventInfo)) {
        subjectProp = 'subjects';
    }
    let innerHTML = '';
    activities.forEach((activity) => {
        innerHTML += `
    <div class="activity">
      <ul class="customEventInfo">
        <li>
          <img class="avatar" src="${activity[subjectProp][0] ? whiteAreaIcons[activity[subjectProp][0].icon] : ''}" />
          ${activity[subjectProp][0] ? activity[subjectProp][0].name : ''}
        </li>
        <li>
            <img class="avatar" src="${activity.teacher ? activity.teacher.avatar : ''}" />
            ${activity.teacher ? activity.teacher.name : ''}
          </li>
          <li>
          <span class="avatar" style="background-color:${activity.room ? activity.room.color : ''};"></span>
          ${activity.room ? activity.room.name : ''}
        </li>
        <li>${createGroupString(activity.groups)}</li>
      </ul>
    </div>
    `;
    });
    return innerHTML;
};
const customTimeslotGroupHTMLString = (eventInfo) => {
    const activities = getActivitiesOrEvents(eventInfo);
    let subjectProp = 'areas';
    if (hasActivities(eventInfo)) {
        subjectProp = 'subjects';
    }
    let innerHTML = '';
    activities.forEach((activity) => {
        innerHTML += `
    <div class="activity">
      <ul class="customEventInfo">
        <li>
          <img class="avatar" src="${activity[subjectProp][0] ? whiteAreaIcons[activity[subjectProp][0].icon] : ''}" />
          ${activity[subjectProp][0] ? activity[subjectProp][0].name : ''}
        </li>
        <li>
            <img class="avatar" src="${activity.teacher ? activity.teacher.avatar : ''}" />
            ${activity.teacher ? activity.teacher.name : ''}
          </li>
          <li>
          <span class="avatar" style="background-color:${activity.room ? activity.room.color : ''};"></span>
          ${activity.room ? activity.room.name : ''}
        </li>
        <li>${createLevelString(activity.levels)}</li>
      </ul>
    </div>
    `;
    });
    return innerHTML;
};
const customTimeslotRoomHTMLString = (eventInfo) => {
    const activities = getActivitiesOrEvents(eventInfo);
    let subjectProp = 'areas';
    if (hasActivities(eventInfo)) {
        subjectProp = 'subjects';
    }
    let innerHTML = '';
    activities.forEach((activity) => {
        if (activity.type !== 'recess') {
            innerHTML += `
      <div class="activity">
        <ul class="customEventInfo">
          <li>
            <img class="avatar" src="${activity[subjectProp][0] ? whiteAreaIcons[activity[subjectProp][0].icon] : ''}" />
            ${activity[subjectProp][0] ? activity[subjectProp][0].name : ''}
          </li>
          <li>
            <img class="avatar" src="${activity.teacher ? activity.teacher.avatar : ''}" />
            ${activity.teacher ? activity.teacher.name : ''}
          </li>
          <li>${createLevelString(activity.levels)}</li>
          <li>${createGroupString(activity.groups)}</li>
        </ul>
      </div>
      `;
        }
    });
    return innerHTML;
};
const customEventTeacherHTMLString = (eventInfo) => {
    const event = eventInfo.event.extendedProps.event;
    let innerHTML = '';
    innerHTML += `
      <div class="activity">
        <ul class="customEventInfo">
          <li>
            <img class="avatar" src="${event.subjects[0] ? whiteAreaIcons[event.subjects[0].icon] : ''} " />
            ${event.subjects[0] ? event.subjects[0].name : ''}
          </li>
          <li>
            <span class="avatar" style="background-color:${event.room ? event.room.color : ''};"></span>
            ${event.room ? event.room.name : ''}
          </li>
          <li>${createLevelString(event.levels)}</li>
          <li>${createGroupString(event.groups)}</li>
        </ul>
    </div>
  `;
    return innerHTML;
};
const customEventSubjectHTMLString = (eventInfo) => {
    const event = eventInfo.event.extendedProps.event;
    let innerHTML = '';
    innerHTML += `
      <div class="activity">
        <ul class="customEventInfo">
          <li>
            <img class="avatar" src="${event.teacher ? event.teacher.avatar : ''}" />
            ${event.teacher ? event.teacher.name : ''}
          </li>
          <li>
            <span class="avatar" style="background-color:${event.room ? event.room.color : ''};"></span>
            ${event.room ? event.room.name : ''}
          </li>
          <li>${createLevelString(event.levels)}</li>
          <li>${createGroupString(event.groups)}</li>
        </ul>
    </div>
  `;
    return innerHTML;
};
const customEventLevelHTMLString = (eventInfo) => {
    const event = eventInfo.event.extendedProps.event;
    let innerHTML = '';
    innerHTML += `
  <div class="activity">
    <ul class="customEventInfo">
      <li>
        <img class="avatar" src="${event.teacher ? whiteAreaIcons[event.teacher.icon] : ''} " />
        ${event.teacher ? event.teacher.name : ''}
      </li>
      <li>
        <img class="avatar" src="${event.subjects[0] ? whiteAreaIcons[event.subjects[0].icon] : ''} " />
        ${event.subjects[0] ? event.subjects[0].name : ''}
      </li>
      <li>
        <span class="avatar" style="background-color:${event.room ? event.room.color : ''};"></span>
        ${event.room ? event.room.name : ''}
      </li>
      <li>${createGroupString(event.groups)}</li>
    </ul>
  </div>
  `;
    return innerHTML;
};
const customEventGroupHTMLString = (eventInfo) => {
    const event = eventInfo.event.extendedProps.event;
    let innerHTML = '';
    innerHTML += `
  <div class="activity">
    <ul class="customEventInfo">
      <li>
        <img class="avatar" src="${event.teacher ? whiteAreaIcons[event.teacher.icon] : ''} " />
        ${event.teacher ? event.teacher.name : ''}
      </li>
      <li>
        <img class="avatar" src="${event.subjects[0] ? whiteAreaIcons[event.subjects[0].icon] : ''} " />
        ${event.subjects[0] ? event.subjects[0].name : ''}
      </li>
      <li>
        <span class="avatar" style="background-color:${event.room ? event.room.color : ''};"></span>
        ${event.room ? event.room.name : ''}
      </li>
      <li>${createLevelString(event.levels)}</li>
    </ul>
  </div>
  `;
    return innerHTML;
};
const customEventRoomHTMLString = (eventInfo) => {
    const event = eventInfo.event.extendedProps.event;
    let innerHTML = '';
    innerHTML += `
  <div class="activity">
    <ul class="customEventInfo">
      <li>
        <img class="avatar" src="${event.teacher ? whiteAreaIcons[event.teacher.icon] : ''} " />
        ${event.teacher ? event.teacher.name : ''}
      </li>
      <li>
        <img class="avatar" src="${event.subjects[0] ? whiteAreaIcons[event.subjects[0].icon] : ''} " />
        ${event.subjects[0] ? event.subjects[0].name : ''}
      </li>
      <li>${createLevelString(event.levels)}</li>
      <li>${createGroupString(event.groups)}</li>
    </ul>
  </div>
  `;
    return innerHTML;
};
